import React, { useState } from "react";
import { EventsListLogic } from "../EventsListLogic";
import { branding } from "../../config";

export function EventsListPublic(props) {
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  function handleClick(event) {
    setSelectedEvent(event);
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
    setSelectedEvent(null);
  }

  return (
    <EventsListLogic
      {...props}
      onlyPublic={true}
      render={({ upcoming, past, showPast, openIndex, toggleOpen }) => (
        <div className="container">
          <style>{`
            .events-scroll-container::-webkit-scrollbar {
              height: 8px;
            }
            .events-scroll-container::-webkit-scrollbar-track {
              background: #f0f0f0;
              border-radius: 4px;
            }
            .events-scroll-container::-webkit-scrollbar-thumb {
              background: ${branding.primaryColor};
              border-radius: 4px;
            }
            .events-scroll-container::-webkit-scrollbar-thumb:hover {
              background: ${branding.primaryColor}dd;
            }
          `}</style>

          {showModal && selectedEvent && (
            <>
              {/* Simulated Bootstrap backdrop */}
              <div
                className="modal-backdrop fade show"
                onClick={closeModal}
                style={{ zIndex: 1040 }}
              ></div>

              {/* Modal */}
              <div
                className="modal d-block fade show"
                tabIndex="-1"
                role="dialog"
                style={{ zIndex: 1050 }}
                onClick={closeModal}
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="modal-content">
                    <div className="modal-header" style={{ borderBottom: `2px solid ${branding.primaryColor}` }}>
                      <h5 className="modal-title ms-auto fw-bold" style={{ color: branding.primaryColor }}>
                        {selectedEvent.name}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={closeModal}
                      ></button>
                    </div>
                    <div className="modal-body">
                      {selectedEvent.description && (
                        <p className="mb-3" style={{ color: '#6c757d', lineHeight: '1.6' }}>
                          {selectedEvent.description}
                        </p>
                      )}
                      
                      <div className="mb-2">
                        <i className="fa-solid fa-calendar-days me-2" style={{ color: branding.primaryColor, width: '20px' }} />
                        <span className="fw-semibold" style={{ color: '#495057' }}>
                          {new Date(selectedEvent.date + "T00:00").toLocaleDateString(undefined, {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                          })}
                        </span>
                      </div>

                      {selectedEvent.location && (
                        <div className="mb-1">
                          <i className="fa-solid fa-location-dot me-2" style={{ color: branding.primaryColor, width: '20px' }} />
                          <span className="fw-semibold" style={{ color: '#495057' }}>
                            {selectedEvent.location}
                          </span>
                        </div>
                      )}
                      
                      {selectedEvent.address && (
                        <div className="mb-3 ms-4 ps-2" style={{ color: '#6c757d', fontSize: '0.9rem' }}>
                          {selectedEvent.address}
                        </div>
                      )}

                      {/* Contacts */}
                      {Array.isArray(selectedEvent.contacts) && selectedEvent.contacts.length > 0 && (
                        <div className="mt-3">
                          <div className="mb-2">
                            <i className="fa-solid fa-address-book me-2" style={{ color: branding.primaryColor, width: '20px' }} />
                            <span className="fw-semibold" style={{ color: '#495057' }}>
                              Contact{selectedEvent.contacts.length > 1 ? 's' : ''}:
                            </span>
                          </div>
                          <ul className="mb-0 ms-4 ps-2" style={{ listStyleType: "none", paddingLeft: 0 }}>
                            {selectedEvent.contacts.map((contact, i) => (
                              <li key={i} className="mb-1" style={{ color: '#6c757d', fontSize: '0.9rem' }}>
                                {contact.name && <strong style={{ color: '#495057' }}>{contact.name}</strong>}
                                {contact.phone && <span> • {contact.phone}</span>}
                                {contact.email && (
                                  <span>
                                    {' • '}
                                    <a 
                                      href={`mailto:${contact.email}`} 
                                      style={{ color: branding.primaryColor, textDecoration: 'none' }}
                                      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                                    >
                                      {contact.email}
                                    </a>
                                  </span>
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {/* Itinerary */}
                      {Array.isArray(selectedEvent.time) && selectedEvent.time.length > 0 && (
                        <div className="mt-3">
                          <div className="mb-2">
                            <i className="fa-solid fa-clipboard-list me-2" style={{ color: branding.primaryColor, width: '20px' }} />
                            <span className="fw-semibold" style={{ color: '#495057' }}>Itinerary:</span>
                          </div>
                          <ul className="mb-0 ms-4 ps-2" style={{ listStyleType: "none", paddingLeft: 0 }}>
                            {selectedEvent.time.map((t, i) => (
                              <li key={i} className="mb-1" style={{ color: '#6c757d', fontSize: '0.9rem' }}>
                                {t.time && (
                                  <strong style={{ color: branding.primaryColor }}>
                                    {new Date(`2000-01-01T${t.time}`).toLocaleTimeString(undefined, {
                                      hour: 'numeric',
                                      minute: '2-digit',
                                      hour12: true
                                    })}
                                  </strong>
                                )}
                                {t.description && <span>{t.time ? ' — ' : ''}{t.description}</span>}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {upcoming.length === 0 ? (
            <div className="text-center py-0">
              <p className="text-muted" style={{ fontSize: '1.1rem' }}>
                No upcoming events
              </p>
            </div>
          ) : (
            <div className="events-scroll-container" style={{
              display: 'flex',
              overflowX: 'auto',
              gap: '1rem',
              paddingBottom: '1rem',
              scrollbarWidth: 'thin',
              scrollbarColor: `${branding.primaryColor} #f0f0f0`
            }}>
              {upcoming.map((event, index) => (
              <div key={index} style={{ minWidth: '320px', maxWidth: '320px' }}>
                <div className="card h-100 shadow-sm" style={{ border: 'none' }}>
                  <div className="card-body">
                    <h6 className="card-title fw-bold" style={{ color: branding.primaryColor }}>
                      {event.name}
                    </h6>
                    
                    <div className="mb-2">
                      <i className="fa-solid fa-calendar-days me-2" style={{ color: branding.primaryColor, fontSize: '0.9rem' }} />
                      <span className="small fw-semibold" style={{ color: '#495057' }}>
                        {new Date(event.date + "T00:00").toLocaleDateString(undefined, {
                          weekday: "short",
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        })}
                      </span>
                    </div>

                    {event.description && (
                      <p className="card-text text-muted small" style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        marginBottom: '0.75rem'
                      }}>
                        {event.description}
                      </p>
                    )}
                    
                    {event.location && (
                      <p className="card-text mb-1 small">
                        <i className="fa-solid fa-location-dot me-2" style={{ color: branding.primaryColor, fontSize: '0.9rem' }}></i>
                        <span style={{ color: '#495057' }}>{event.location}</span>
                      </p>
                    )}
                    
                    {event.time && event.time.length > 0 && event.time[0].time && (
                      <p className="card-text mb-2 small">
                        <i className="fa-solid fa-clock me-2" style={{ color: branding.primaryColor, fontSize: '0.9rem' }}></i>
                        <span style={{ color: '#495057' }}>
                          {new Date(`2000-01-01T${event.time[0].time}`).toLocaleTimeString(undefined, {
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: true
                          })}
                        </span>
                      </p>
                    )}
                    
                    <button 
                      onClick={() => handleClick(event)} 
                      className="btn btn-sm btn-outline-primary mt-2"
                      style={{ 
                        borderColor: branding.primaryColor, 
                        color: branding.primaryColor,
                        fontSize: '0.875rem'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = branding.primaryColor;
                        e.target.style.color = 'white';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = branding.primaryColor;
                      }}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              </div>
              ))}
            </div>
          )}
        </div>
      )}
    />
  );
}
